import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  SimpleGrid,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Checkbox,
  useToast,
  Icon,
} from "@chakra-ui/react";
import {
  FaPlus,
  FaCheckCircle,
  FaMoneyBillWave,
  FaChalkboardTeacher,
  FaUserGraduate,
  FaLayerGroup,
  FaSchool,
  FaUser,
} from "react-icons/fa"; // Import the Font Awesome "plus" icon
import { BASE_URL } from "../../../../Globalapi/Globalapi";

const CreateMember = () => {
  const toast = useToast();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [memberName, setMemberName] = useState("");
  const [memberType, setMemberType] = useState("");
  const [amount, setAmount] = useState("");
  const [isPaid, setIsPaid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchClasses = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/class/class_master.php`
      );
      setClasses(response.data.data || []);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchTeachers = async () => {
    setLoading(true);
    try {
      const jwt = sessionStorage.getItem("jwt");
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      setTeachers(response.data.data);
      // if (response.data.status === "success") {
      //   setTeachers(response.data.data);
      // } else {
      //   setError(response.data.message || "Error fetching teachers");
      // }
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setError("Network Error: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  };

  const fetchDivisions = async () => {
    if (!selectedClass) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/class/division.php`,
        {
          params: { class_id: selectedClass },
        }
      );
      setDivisions(response.data.data || []);
    } catch (error) {
      console.error("Error fetching divisions:", error);
    }
  };

  const fetchStudents = async () => {
    if (!selectedClass || !selectedDivision) return;
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/exam/depending_student.php`,
        {
          class_id: selectedClass,
          division_id: selectedDivision,
        }
      );
      setStudents(response.data.data || []);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const handleCreateMember = async () => {
    const data = {
      member_name: memberName,
      member_type: memberType,
      teacher_id: memberType === "Teacher" ? selectedTeacher : null,
      student_id: memberType === "Student" ? selectedStudent : null,
      amount: amount,
      is_paid: isPaid ? 1 : 0,
      created_by: sessionStorage.getItem("user_id"), // assuming 1 is the logged-in user's ID, you should adjust this
      school_id: sessionStorage.getItem("school_id"), // same for school_id, replace as needed
    };
    console.log("data for create", data);

    try {
      const response = await axios.post(
        `${BASE_URL}/admin/library/membership/create_member.php`,
        data
      );
      console.log("create", response);

      if (response.data.success) {
        toast({
          title: "Member Created successfully.",
          description: "The member has been created succesfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setIsModalOpen(false);
      } else {
        alert("Error: " + response.data.message);
      }
    } catch (error) {
      console.error("Error creating member:", error);
      alert("Network error or validation error.");
    }
  };

  useEffect(() => {
    fetchClasses();
    fetchTeachers();
  }, []);

  useEffect(() => {
    fetchDivisions();
  }, [selectedClass]);

  useEffect(() => {
    fetchStudents();
  }, [selectedClass, selectedDivision]);

  return (
    <div>
      {/* Button to open the modal */}
      <Button
        onClick={() => setIsModalOpen(true)}
        colorScheme="purple"
        // mb={4}
        size={{ base: "xs", md: "md" }}
        leftIcon={<FaPlus />}
      >
        School{" "}
      </Button>
      {/* Chakra UI Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaPlus} boxSize={5} mr={2} />
            Create New Member
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              {/* Member Name */}
              {/* <FormControl isRequired>
              <FormLabel>Member Name</FormLabel>
              <Input
                type="text"
                value={memberName}
                onChange={(e) => setMemberName(e.target.value)}
              />
            </FormControl> */}

              {/* Member Type */}
              <FormControl isRequired mt={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaUser} mr={1} color="teal.500" />
                  Member Type
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={memberType}
                  onChange={(e) => setMemberType(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Teacher">Teacher</option>
                  <option value="Student">Student</option>
                </Select>
              </FormControl>

              {/* Class & Division (only if member type is Student) */}
              {memberType === "Student" && (
                <>
                  <FormControl isRequired mt={4}>
                    <FormLabel>
                      {" "}
                      <Icon as={FaSchool} mr={1} color="teal.500" />
                      Class
                    </FormLabel>
                    <Select
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={selectedClass}
                      onChange={(e) => setSelectedClass(e.target.value)}
                    >
                      <option value="">Select Class</option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl isRequired mt={4}>
                    <FormLabel>
                      {" "}
                      <Icon as={FaLayerGroup} mr={1} color="teal.500" />
                      Division
                    </FormLabel>
                    <Select
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={selectedDivision}
                      onChange={(e) => setSelectedDivision(e.target.value)}
                    >
                      <option value="">Select Division</option>
                      {divisions.map((division) => (
                        <option key={division.id} value={division.id}>
                          {division.division}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl isRequired mt={4}>
                    <FormLabel>
                      {" "}
                      <Icon as={FaUserGraduate} mr={1} color="teal.500" />
                      Student
                    </FormLabel>
                    <Select
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={selectedStudent}
                      onChange={(e) => {
                        const studentId = e.target.value;
                        const student = students.find(
                          (student) => student.id === studentId
                        );
                        setSelectedStudent(studentId);
                        setMemberName(student.name); // Set the student's name to memberName
                      }}
                    >
                      <option value="">Select Student</option>
                      {students.map((student) => (
                        <option key={student.id} value={student.id}>
                          {student.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </>
              )}

              {/* Teacher selection (only if member type is Teacher) */}
              {memberType === "Teacher" && (
                <FormControl isRequired mt={4}>
                  <FormLabel>
                    {" "}
                    <Icon as={FaChalkboardTeacher} mr={1} color="teal.500" />
                    Teacher
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={selectedTeacher}
                    onChange={(e) => {
                      const teacherId = e.target.value;
                      console.log("Selected Teacher ID:", teacherId); // Debugging
                      const teacher = teachers.find(
                        (t) => String(t.id) === String(teacherId)
                      );

                      if (teacher) {
                        setSelectedTeacher(teacherId);
                        setMemberName(teacher.name); // Set the teacher's name to memberName
                      } else {
                        console.error("Teacher not found in list", teachers);
                      }
                    }}
                  >
                    <option value="">Select Teacher</option>
                    {teachers.map((teacher) => (
                      <option key={teacher.id} value={teacher.id}>
                        {teacher.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              )}

              {/* Amount */}
              <FormControl isRequired mt={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaMoneyBillWave} mr={1} color="teal.500" />
                  Amount
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </FormControl>
              {/* Paid Checkbox */}
              <FormControl mt={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaCheckCircle} mr={1} color="teal.500" />
                  Paid
                </FormLabel>
                <Checkbox
                  isChecked={isPaid}
                  onChange={(e) => setIsPaid(e.target.checked)}
                >
                  Yes
                </Checkbox>
              </FormControl>
            </SimpleGrid>
          </ModalBody>

          {/* Modal Footer with Create Button */}
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleCreateMember}
            >
              Create
            </Button>
            {/* <Button variant="ghost" onClick={() => setIsModalOpen(false)}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default CreateMember;
